import countryList from 'react-select-country-list';

import { CUSTOM_COUNTRY_LABELS, SUPPORTED_COUNTRY_CODES } from '../constants';

/**
 * Return cookie domain in format ".example.com" from current location.hostname.
 * @returns {string}
 */
export const getCookieDomain = () => { // eslint-disable-line import/prefer-default-export
  const fullHostname = window.location.hostname;
  const hostnameParts = fullHostname.split('.');

  if (hostnameParts.length > 2) {
    return `.${hostnameParts.slice(-2).join('.')}`;
  }

  return fullHostname;
};

/**
 * Return supported countries' data. Each data item contain the country code and label.
 * @returns {Array}
 */
export const buildSupportedCountriesData = () => (
  countryList().getData().filter((country) => SUPPORTED_COUNTRY_CODES.includes(country.value))
);

/**
 * Return country objects with custom country labels.
 *
 * @param {Array} countriesData   Country objects with country code and label.
 * @returns {Array}
 */
export const customizeCountryLabels = (countriesData) => (
  countriesData.map(
    (country) => (
      country.value in CUSTOM_COUNTRY_LABELS
        ? { ...country, label: CUSTOM_COUNTRY_LABELS[country.value] }
        : country
    ),
  )
);
